export default (mediaStream, oldTrack, newTrack) => {
  if (oldTrack === newTrack || !oldTrack || !newTrack) {
    return;
  }

  mediaStream.removeTrack(oldTrack);
  mediaStream.addTrack(newTrack);
};
